import { GitHubCommitResponse } from "../model/CommitModel.js";

export function parseGitHubCommitURL(url: string) {
  let match = url.match(/github\.com\/([^/]+)\/([^/]+)\/commit\/([a-f0-9]+)/i);

  if (match) {
    return {
      owner: match[1],
      repo: match[2],
      sha: match[3],
    };
  }

  match = url.match(
    /github\.com\/([^/]+)\/([^/]+)\/pull\/\d+\/commits\/([a-f0-9]+)/i
  );

  if (match) {
    return {
      owner: match[1],
      repo: match[2],
      sha: match[3],
    };
  }

  return null;
}

export function formatCommitData(data: any): GitHubCommitResponse {
  return {
    stats: {
      total: data.stats?.total ?? 0,
      additions: data.stats?.additions ?? 0,
      deletions: data.stats?.deletions ?? 0,
    },
    files: (data.files || [])
      .filter((file: any) => getLanguageFromFilename(file.filename) != null)
      .map((file: any) => ({
        filename: file.filename,
        status: file.status,
        additions: file.additions,
        deletions: file.deletions,
        changes: file.changes,
        language: getLanguageFromFilename(file.filename),
        patch: file.patch,
      })),
  };
}

export async function fetchCommitData(
  owner: string,
  repo: string,
  sha: string
): Promise<GitHubCommitResponse> {
  const res = await fetch(
    `https://api.github.com/repos/${owner}/${repo}/commits/${sha}`
  );
  const data = await res.json();
  return formatCommitData(data);
}

export function getLanguageFromFilename(filename: string): string | null {
  const parts = filename.split(".");
  if (parts.length < 2) return null;

  const ext = parts.pop();
  if (!ext) return null;

  if (ext.toLowerCase() === "ts") return "typescript";
  if (ext.toLowerCase() === "py") return "python";
  if (ext.toLowerCase() === "js") return "javascript";
  if (ext.toLowerCase() === "go") return "go";
  if (ext.toLowerCase() === "tsx") return "tsx";
  return null;
}
